export default "/packs/d50a283a78cf57671ad60fe9c8193e94.svg";